export const NEW_YEARS = 'newYears';
export const VALENTINES = 'valentines';
export const EASTER = 'easter';
export const ST_PATRICKS = 'saintPatricks';
export const FOURTH_OF_JULY = '4thOfJuly';
export const HALLOWEEN = 'halloween';
export const THANKSGIVING = 'thanksgiving';
export const CHRISTMAS = 'christmas';
export const HOLIDAYS = {
  NEW_YEARS,
  VALENTINES,
  EASTER,
  ST_PATRICKS,
  FOURTH_OF_JULY,
  HALLOWEEN,
  THANKSGIVING,
  CHRISTMAS
};
export function checkHoliday(dateTime) {
  // check for market holidays
  //dateTime = new Date("2019-11-22T12:01:00Z"); // for testing purposes

  if (isNewYears(dateTime)) {
    return NEW_YEARS;
  } else if (isValentines(dateTime)) {
    return VALENTINES;
  } else if (isStPatricks(dateTime)) {
    return ST_PATRICKS;
  } else if (isEaster(dateTime)) {
    return EASTER;
  } else if (is4thOfJuly(dateTime)) {
    return FOURTH_OF_JULY;
  } else if (isHalloween(dateTime)) {
    return HALLOWEEN;
  } else if (isThanksgiving(dateTime)) {
    return THANKSGIVING;
  } else if (isChristmas(dateTime)) {
    return CHRISTMAS;
  }
  return false;
}

//Most of this was adapted from https://www.mresoftware.com/holiday_script.htm
function getEasterDate(Y) {
  // calculates Easter Sunday based on year
  const C = Math.floor(Y / 100);
  const N = Y - 19 * Math.floor(Y / 19);
  const K = Math.floor((C - 17) / 25);
  let I = C - Math.floor(C / 4) - Math.floor((C - K) / 3) + 19 * N + 15;
  I = I - 30 * Math.floor(I / 30);
  I = I - Math.floor(I / 28) * (1 - Math.floor(I / 28) * Math.floor(29 / (I + 1)) * Math.floor((21 - N) / 11));
  let J = Y + Math.floor(Y / 4) + I + 2 - C + Math.floor(C / 4);
  J = J - 7 * Math.floor(J / 7);
  const L = I - J;
  let month = 3 + Math.floor((L + 40) / 44);
  let day = L + 28 - 31 * Math.floor(month / 4);
  if (day <= 0) {
    day = day + 31; // correct day if we went back to March
    month = 3; // correct month
  }

  const easterMonthDate = new Date().setMonth(parseInt(String(month - 1), 10));
  const easterDate = new Date(easterMonthDate).setDate(parseInt(String(day), 10));
  return new Date(easterDate);
}
function isNewYears(currentDate, rangeInDays = 6) {
  //January is month 0 in Date()
  if (currentDate.getDate() === 1 && currentDate.getMonth() === 0) {
    return true;
  }

  //Note that month is value from 0-11. So we use a 13 for January of next year
  const newYearsDate = getHolidayDate(13, 1);
  const leadingDate = getLeadingDate(newYearsDate, rangeInDays);
  return isDateWithinRange(currentDate, newYearsDate, leadingDate);
}
function isValentines(currentDate, rangeInDays = 7) {
  const valentinesDate = getHolidayDate(2, 14);
  const leadingDate = getLeadingDate(valentinesDate, rangeInDays);
  return isDateWithinRange(currentDate, valentinesDate, leadingDate);
}
function isStPatricks(currentDate, rangeInDays = 7) {
  const stPatricksDate = getHolidayDate(3, 17);
  const leadingDate = getLeadingDate(stPatricksDate, rangeInDays);
  return isDateWithinRange(currentDate, stPatricksDate, leadingDate);
}
function isEaster(currentDate, rangeInDays = 7) {
  const easterDate = getEasterDate(currentDate.getFullYear());
  const leadingDate = getLeadingDate(easterDate, rangeInDays);
  return isDateWithinRange(currentDate, easterDate, leadingDate);
}
function is4thOfJuly(currentDate, rangeInDays = 7) {
  const fourthOfJulyDate = getHolidayDate(7, 4);
  const leadingDate = getLeadingDate(fourthOfJulyDate, rangeInDays);
  return isDateWithinRange(currentDate, fourthOfJulyDate, leadingDate);
}
function isHalloween(currentDate, rangeInDays = 7) {
  const halloweenDate = getHolidayDate(10, 31);
  const leadingDate = getLeadingDate(halloweenDate, rangeInDays);
  return isDateWithinRange(currentDate, halloweenDate, leadingDate);
}
function isThanksgiving(currentDate, rangeInDays = 7) {
  const thanksgivingDate = getWeekBasedHolidayDate(11, 5, 4);
  const leadingDate = getLeadingDate(thanksgivingDate, rangeInDays);
  return isDateWithinRange(currentDate, thanksgivingDate, leadingDate);
}
function isChristmas(currentDate, rangeInDays = 7) {
  const christmasDate = getHolidayDate(12, 25);
  const leadingDate = getLeadingDate(christmasDate, rangeInDays);
  return isDateWithinRange(currentDate, christmasDate, leadingDate);
}
function getHolidayDate(month, date) {
  //Note that month is value from 0-11. So we subtract 1 from the month
  const monthDate = new Date().setMonth(month - 1);
  const holidayDate = new Date(monthDate).setDate(date);
  return new Date(holidayDate);
}

//The logic of this method comes from https://stackoverflow.com/questions/18326446/how-to-calculate-holidays-for-the-usa
function getWeekBasedHolidayDate(month, week, dayOfWeek) {
  //Note that month is value from 0-11. So we subtract 1 from the month
  const monthDate = new Date().setMonth(month - 1);
  const firstDayOfMonth = new Date(monthDate).setDate(1);
  const dayOfTheWeekOffset = new Date(firstDayOfMonth).setDate(new Date(firstDayOfMonth).getDate() - dayOfWeek - 1);

  //The date of the first "day of the week" that occurs for this month (e.g. the first Thursday of the month)
  const firstInstanceOfDayOfWeek = new Date(firstDayOfMonth).setDate(new Date(firstDayOfMonth).getDate() + (6 - new Date(dayOfTheWeekOffset).getDay()));
  let returnDate = new Date(firstInstanceOfDayOfWeek).setDate(new Date(firstInstanceOfDayOfWeek).getDate() + (week - 1) * 7);

  //If the day is past the end of month, then adjust backwards a week
  if (returnDate >= new Date(firstDayOfMonth).setMonth(new Date(firstDayOfMonth).getMonth() + 1)) {
    returnDate = new Date(returnDate).setDate(new Date(returnDate).getDate() - 7);
  }
  return new Date(returnDate);
}
function getLeadingDate(targetDate, rangeInDays) {
  const leadingDate = new Date(targetDate).setDate(new Date(targetDate).getDate() - rangeInDays);
  return new Date(leadingDate);
}
function isDateWithinRange(currentDate, holidayDate, leadingDate) {
  return currentDate.getTime() >= leadingDate.getTime() && currentDate.getTime() <= holidayDate.getTime();
}